import React, { useState } from 'react';
import QueryItems from './QueryItems';
import './style.scoped.scss';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

const Collapse = (props) => {
  const { itemName } = props;
  const [isOpen, setIsOpen] = useState(true);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        className="separator"
        data-toggle="collapse"
        data-target={`#${itemName}`}
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-controls={itemName}
        onClick={toggleCollapse}
      >
        {itemName}
        {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </div>
      <div className={`collapse ${isOpen ? 'show' : ''}`} id={itemName}>
        <div className="cardList cardList-body">
          <QueryItems {...props} />
        </div>
      </div>
    </>
  );
};

export default Collapse;
